/* One shared <audio> for local previews - the voice sampler, "listen here" and
   "last clip" all borrow it, so starting one stops the last, exactly like the
   single #local-audio element the panel used to carry in its markup. */

let element: HTMLAudioElement | null = null;

function shared(): HTMLAudioElement {
  if (!element) element = new Audio();
  return element;
}

export function playLocal(url: string): void {
  const audio = shared();
  audio.src = url;
  void audio.play().catch(() => {
    /* autoplay policy, or the file vanished - nothing useful to say */
  });
}

/* Mobile Safari will not let an <audio> element make a sound unless its *first*
   play() happened inside a user gesture, and it remembers that per element, not
   per page. Ours never qualifies: every local preview is started from a click
   handler, but by then it has already awaited a fetch or a socket frame, so the
   gesture has expired and the element stays muted for the life of the tab —
   "Listen here" silently doing nothing on every iPhone.

   Starting it on a silent one-frame wav inside the first real touch spends that
   gesture on the element once, and every later play() inherits the permission.
   Fire-and-forget: a browser that does not need this rejects or ignores it and
   nothing downstream cares. */
const SILENCE =
  "data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAgD4AAAB9AAACABAAZGF0YQAAAAA=";

export function installAudioUnlock(): void {
  const unlock = () => {
    const audio = shared();
    audio.src = SILENCE;
    void audio.play().catch(() => {});
  };
  // `once`, and on touchend rather than touchstart: a gesture that turned out
  // to be the start of a scroll is not a tap, and iOS does not count it.
  document.addEventListener("touchend", unlock, { once: true, passive: true });
  document.addEventListener("pointerdown", unlock, { once: true });
}
